import { render, staticRenderFns } from "./BDXEditFormFCPStartDate.vue?vue&type=template&id=22587ba1&scoped=true"
import script from "./BDXEditFormFCPStartDate.vue?vue&type=script&lang=js"
export * from "./BDXEditFormFCPStartDate.vue?vue&type=script&lang=js"
import style0 from "./BDXEditFormFCPStartDate.vue?vue&type=style&index=0&id=22587ba1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22587ba1",
  null
  
)

export default component.exports